import {
  DISPLAY_WARNING,
  CONFIRM_WARNING,
  CLOSE_WARNING,
} from '../actions/cancelOrderChangesWarning';

export const initialState = {
  warningVisible: false,
};

export default function multiSearch(state = initialState, action) {
  switch (action.type) {
    case DISPLAY_WARNING:
      return { warningVisible: true };
    case CONFIRM_WARNING: // intentional fall-through
    case CLOSE_WARNING:
      return { warningVisible: false };
    default:
      return state;
  }
}
